import {Menu } from "@headlessui/react";
import React from "react";
import { Link } from "react-router-dom";

export default function MenuItem({url,name,icon}){
    
return(
    <Menu.Item>
    <Link to={url} className="bg-white block group py-2 text-sm font-medium text-gray-700 group-hover:text-gray-900">
    <div className="flex items-center cursor-pointer group-hover:text-gray-900">
      <div className="pl-4 mr-3">
      {icon}
      </div>
     {name}
    </div>
    </Link>
    </Menu.Item>
)
}